import { type MouseEventHandler, useCallback } from 'react';
import { FilledButton } from 'components';
import { FormattedMessage } from 'react-intl';
import useStyles from './OnBoardingReplayButton.styles';
import { useMutation } from '@apollo/client';
import {
  UPDATE_ONBOARDING_COMPLETION_MUTATION,
  UpdateOnBoardingCompletionOutput,
} from 'graphql/webuser/WebUserMutations';

type OnBoardingReplayButtonPureProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const OnBoardingReplayButtonPure = ({
  onClick,
}: OnBoardingReplayButtonPureProps): JSX.Element => {
  const classes = useStyles();
  return (
    <FilledButton className={classes.button} color="violet" onClick={onClick}>
      <FormattedMessage id="profile.on_boarding_replay.button" />
    </FilledButton>
  );
};

const OnBoardingReplayButton = (): JSX.Element => {
  const [updateOnBoardingCompletion] = useMutation<UpdateOnBoardingCompletionOutput>(
    UPDATE_ONBOARDING_COMPLETION_MUTATION,
    {
      refetchQueries: ['GetMe'],
    },
  );

  const handleClick = useCallback(async () => {
    await updateOnBoardingCompletion({
      variables: {
        input: {
          onBoardingCompleted: false,
        },
      },
    });
  }, [updateOnBoardingCompletion]);

  return <OnBoardingReplayButtonPure onClick={handleClick} />;
};

export default OnBoardingReplayButton;
